<!-- Use este arquivo como base para novos módulos de CRUD, -->
<!-- apenas copiando ele e colando na pasta respectiva -->

<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onUpdate="() => {}"
    :enableSearch="true"
    :formInputs="formInputs"
    primaryKey="id"
    :alertMessage="alertMessage"
  />
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import {
  schemaColorPicker,
  schemaSelect,
  schemaTextField
} from "@/helpers/form";

export default {
  name: "tintometrico-corante",
  components: {
    CrudBase,
  },
  props: [
    'fabricantes'
  ],
  data() {
    return {
      alertMessage: 'Vincule um código de produto ao corante para preencher o EAN de acordo com o código de barras de cadastro.',
      url: "/admin/tintometrico/corante",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "Cód.", field: "id_externo", sortable: false },
        { label: "Nome", field: "nome", sortable: false },
        { label: "Volume ml", field: "volume_ml", sortable: false },
        { label: "EAN", field: "ean", sortable: false },
        { label: "Fabricante", field: "fabricante_nome", sortable: false }
      ],
      formInputs: {
        produto_id: schemaTextField('ID Produto', false, 3),
        nome: schemaTextField('Nome', false, 12, this.disabledOption()),
        ean: schemaTextField('EAN', false, 12, this.disabledOption()),
        volume_ml: schemaTextField('Volume ml', false, 2, this.disabledOption()),
        fabricante_id: schemaSelect('Fabricante', false, 4, this.fabricantes, null, this.disabledOption()),
      },
    };
  },
  methods: {
    disabledOption() {
      return {
        "disabled": true
      }
    }
  }
};
</script>
